export default {
    data() {
        return {
            searchFilterNames: {
                'noImagesAdmin': 'No Images',
                'hasImagesAdmin': 'Has Images',
                'isActive': 'Active',
                'offsite': 'Off-site',
                'active': 'Active',
                'inactive': 'Inactive',
                'cover': 'Cover parts',
                'disc': 'Disc parts',
                'discCount': 'Disc Count',
                'locationFrom': 'Location',
                'locationTo': 'Location To',
                'source': 'Source',
                'addedBy': 'Added By',
                'added': 'Added',
                'addedTo': 'Added To',
                'genre': 'Genre',
                'price': 'Price',
                'format': 'Format',
                'adminGrade': 'Grade',
                'subject': 'Subject',
                'origin': 'Origin',
                'integrationId': 'Integration ID',
                'noDiscogsId': 'No Discogs ID',
                'noAmazonId': 'No Amazon ID',
                'orderDate': 'Order From',
                'orderDateTo': 'Order To',
                'noSalesSince': 'No Sales Since',
                'platform': 'Platform',
                'orderSource': 'Order Source',
                'orderAddedBy': 'Order Item Added By',
                'hype': 'Hype',
                'mediaAttrs': 'Media Attributes',
                'pressingNotes': 'Pressing Notes',
                'noLocation': 'No Location',
                'noSource': 'No Source',
                'noPrice': 'No Price',
                'suppressed': 'Suppressed On',
                'catalogNumber': 'Catalog Number',
                'speed': 'Speed',
                'size': 'Size',
                'imageDateFrom': 'Photo Date From',
                'imageDateTo': 'Photo Date To',
                'inactiveUpdatedBy': "Inactive Updated By",
                'inactiveUpdated': "Inactive Updated",
                'inactiveUpdatedTo': "Inactive Updated To",
                'integrationAddedBy': "Integration Added By",
                'integrationAdded': "Integration Added",
                'integrationAddedTo': "Integration Added To",
                'integrationPlatform': "Integration Platform",
            }
        }
    }
}
